import React from 'react'
import { FaCheck, FaRegLightbulb } from "react-icons/fa";
import { AiOutlineAim } from "react-icons/ai";
import { t } from 'i18next';
import i18n from '../i18';

export const AboutPages = () => {
    const language = i18n.language;

    const textAlign = language === 'ar' || language === 'kr' ? 'text-right' : 'text-left';

    return (
        <div className="mt-20 px-6 md:px-24">

            {/* Page Header */}
            <div className="text-center mb-20">
                <h2 className="text-4xl md:text-5xl font-bold tracking-wide text-[#1a0080]">
                    {t('aboutus.heading1')}
                </h2>
                <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto mt-5 leading-relaxed">
                    {t('aboutus.heading2')}
                </p>
            </div>

            {/* About Content Blocks */}
            <div className="space-y-4">

                {/* Block 1 */}
                <div className="
                    flex flex-col md:flex-row gap-6 items-start
                    border border-gray-200 bg-white rounded-2xl 
                    p-8 shadow-sm hover:shadow-md transition-all duration-300
                ">
                    <div className="bg-[#1a0080] text-white p-3 rounded-full shadow-sm">
                        <FaCheck size={20} />
                    </div>
                    <p className={`text-gray-700 text-lg leading-relaxed ${textAlign}`}>
                        {t('aboutus.content1')}
                    </p>
                </div>

                {/* Block 2 */}
                <div className="
                    flex flex-col md:flex-row gap-6 items-start
                    border border-gray-200 bg-white rounded-2xl 
                    p-8 shadow-sm hover:shadow-md transition-all duration-300
                ">
                    <div className="bg-[#1a0080] text-white p-3 rounded-full shadow-sm">
                        <FaCheck size={20} />
                    </div>
                    <p className={`text-gray-700 text-lg leading-relaxed ${textAlign}`}>
                        {t('aboutus.content2')}
                    </p>
                </div>

            </div>

            {/* Mission - Vision */}
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-12">

                {/* Mission Card */}
                <div className="
                    border border-gray-200 bg-white rounded-3xl 
                    p-10 shadow-sm hover:shadow-md transition-all
                ">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="bg-[#1a0080] text-white p-3 rounded-full shadow-sm">
                            <AiOutlineAim size={22} />
                        </div>
                        <h3 className="text-2xl font-semibold text-[#1a0080]">
                            {t('aboutus.mission')}
                        </h3>
                    </div>
                    <p className={`text-gray-700 text-lg leading-relaxed ${textAlign}`}>
                        {t('aboutus.missiontitle')}
                    </p>
                </div>

                {/* Vision Card */}
                <div className="
                    border border-gray-200 mb-2 bg-white rounded-3xl 
                    p-10 shadow-sm hover:shadow-md transition-all
                ">
                    <div className="flex items-center gap-2 mb-2">
                        <div className="bg-[#1a0080] text-white p-3 rounded-full shadow-sm">
                            <FaRegLightbulb size={22} />
                        </div>
                        <h3 className="text-2xl font-semibold text-[#1a0080]">
                            {t('aboutus.vission')}
                        </h3>
                    </div>
                    <p className={`text-gray-700 text-lg leading-relaxed ${textAlign}`}>
                        {t('aboutus.vissiontitle')}
                    </p>
                </div>

            </div>

        </div>
    );
};
